import DataPolicy from './DataPolicy';

export default DataPolicy;
